import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = ({ onMenuClick }) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timerId = setInterval(() => {
      setNow(new Date());
    }, 60000); // Update every minute

    return () => clearInterval(timerId); // Cleanup timer on component unmount
  }, []);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const weekday = weekdays[date.getDay()];
    
    return `${year} ${month}/${day} ${weekday}`;
  };

  const formatTime = (date) => {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <button className="hamburger-btn" onClick={onMenuClick}>
          <span />
          <span />
          <span />
        </button>
        <div className="title-group" onClick={() => window.location.href = 'https://app.ctie-aiems-kyusyu-poc.services/'}>
          <h1 className="header-title">Energy Management System</h1>
          <div className="header-subtitle">
            <span>人工知能</span>
            <span>エネルギーマネジメントシステム</span>
          </div>
        </div>
      </div>
      <div className="header-right">
        <div className="current-date">
          <span className="date-label">TODAY</span>
          <span className="date-string">{formatDate(now)}</span>
          <span className="time-string">{formatTime(now)}</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
 